import React from "react";
import { Button } from "antd";
import { ContainerModal } from "../container/ContainerModal";

export const ModalMigration = ({ loading = false, closeModal = () => { }, updateTask = () => { } }) => {

    return (
        <div className="fixed top-0 left-0 w-full h-full z-50 bg-black bg-opacity-45 flex justify-center items-center">
            <ContainerModal
                title={"Migración"}
                actionButton={closeModal}
                className={"w-[500px]"}
            >
                <div>
                    <p className="text-[12px]">Se va a hacer una migracion de tiempos con lo que hay en clickup</p>
                    <div className="w-full h-[40px] mt-4 overflow-hidden flex justify-end gap-4">
                        <Button
                            onClick={updateTask}
                            type="primary"
                            className="bg-primaryTwo"
                            loading={loading}
                        >
                            Actualizar
                        </Button>
                    </div>
                </div>
            </ContainerModal>
        </div>
    );
};
